const BaseService = {
    base: function () {
        let hostname = location.hostname;
        let endpoint = process.env.VUE_APP_CMH_API_URL;        
        
        if (hostname.includes('cwm') || hostname.includes('war') || hostname.includes('guerre')) {
            endpoint = process.env.VUE_APP_CWM_API_URL;
        }
        
        // endpoint = process.env.VUE_APP_CWM_API_URL;
        return endpoint; // api route
    }
}

export default BaseService;